import { render, staticRenderFns } from "./FileName.vue?vue&type=template&id=527ca534"
import script from "./FileName.vue?vue&type=script&lang=js"
export * from "./FileName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports